import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { LOCALSTORAGE_LOGIN_TYPE, LOCALSTORAGE_LOGIN_TYPE_ACCOUNT } from '../../utils/constants/login'
import { getLoginRedirectPath, getStoredAccessToken } from '../../utils/authSession'

const PrivateRoute = () => {
    const login = window.sessionStorage.getItem(LOCALSTORAGE_LOGIN_TYPE) ?? LOCALSTORAGE_LOGIN_TYPE_ACCOUNT
    const token = getStoredAccessToken()

    return token ? <Outlet /> : <Navigate to={getLoginRedirectPath(login)} />
}

export default PrivateRoute
